import ArtworkPage from "./ArtworkPage"

export default ArtworkPage